// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const uuid = () => {
    let dt = new Date().getTime()
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    return uuid
}

window.uuid = uuid

window._ = require('lodash')

// window.firebaseConf = require('./firebase/config')
const CryptoJS = require('crypto-js')

window.decrypt = (encrypted) => {
    let key = process.env.MIX_APP_KEY.substr(7)
    var encrypted_json = JSON.parse(atob(encrypted))
    return CryptoJS.AES.decrypt(encrypted_json.value, CryptoJS.enc.Base64.parse(key), {
        iv: CryptoJS.enc.Base64.parse(encrypted_json.iv),
    }).toString(CryptoJS.enc.Utf8)
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default
    window.$ = window.jQuery = require('jquery')
    window.toastr = require('toastr')
    window.toastr.options.progressBar = true
    window.moment = require('moment')

    require('bootstrap')
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

import slug from './utils/slug'
import fillObject from './utils/fillObject'
import ifEmpty from './utils/ifEmpty'
window.slug = slug
window.fillObject = fillObject
window.ifEmpty = ifEmpty

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

// ws.intuscolombia.com
// const wsConfig = {
//     broadcaster: 'pusher',
//     key: process.env.MIX_WS_APP_KEY,
//     wsHost: process.env.MIX_WS_HOST,
//     wsPort: process.env.MIX_WS_PORT,
//     encrypted: (process.env.MIX_WS_ENCRYPTED.toLowerCase() === 'true'),
//     disableStats: true,
//     scheme: process.env.MIX_WS_SCHEME,
// }
const wsConfig = {
    broadcaster: 'pusher',
    key: process.env.MIX_WS_APP_KEY,
    cluster: 'us2',
    forceTLS: true,
}

window.Echo = new Echo(wsConfig)

window.getBreakpoint = function () {
    return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '')
}

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyDNhGn__m9CzVXBxIKV1wUNPh8aBmZspFM',
    authDomain: 'vecindapp-8859a.firebaseapp.com',
    projectId: 'vecindapp-8859a',
    storageBucket: 'vecindapp-8859a.appspot.com',
    messagingSenderId: '136751015580',
    appId: '1:136751015580:web:ca72fc1df30f3491856f59',
    measurementId: 'G-8SEK04XQFM',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
// const analytics = getAnalytics(app)


window.toQueryString = (obj) => {
    const keyValuePairs = []
    for (const key in obj) {
        if (!obj[key]) continue
        keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    }
    return keyValuePairs.join('&')
}